export default __webpack_public_path__ + "static/media/ic_tab_lots.4c9b2125.svg";